import React from 'react';
import { ListManager } from '../components';
import { Container, MainWrapper } from 'lib/components/styles/layout';

export const List = () => {
  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <ListManager />
      </MainWrapper>
    </Container>
  );
};
